import type { TPostAutomatedAdvertisementPlacementProps } from './AutomatedAdvertisementPlacement.types';

export const PostAutomatedAdvertisementPlacement = ({ element }: TPostAutomatedAdvertisementPlacementProps) => {
  const kind = element.attrs?.advertisementKind ?? 'primary';
  const labels: Record<string, string> = { primary: 'With logo', secondary: 'Without logo', tertiary: 'Text only' };
  const label = labels[kind] ?? 'With logo';

  return (
    <div
      style={{
        margin: '12px 0',
        padding: '12px 16px',
        border: '1px dashed #d1d5db',
        borderRadius: '6px',
        backgroundColor: '#ffffff',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
          marginBottom: '12px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '24px',
              height: '24px',
              borderRadius: '3px',
              backgroundColor: '#fdf2f8',
              flexShrink: 0,
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256" aria-hidden="true">
              <path
                fill="#be185d"
                d="M80,48a8,8,0,0,1-8,8H40V72a8,8,0,0,1-16,0V56A16,16,0,0,1,40,40H72A8,8,0,0,1,80,48ZM32,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,32,152Zm40,48H40V184a8,8,0,0,0-16,0v16a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16Zm72,0H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm80-24a8,8,0,0,0-8,8v16H184a8,8,0,0,0,0,16h32a16,16,0,0,0,16-16V184A8,8,0,0,0,224,176Zm0-72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,224,104Zm-8-64H184a8,8,0,0,0,0,16h32V72a8,8,0,0,0,16,0V56A16,16,0,0,0,216,40Zm-72,0H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z"
              />
            </svg>
          </span>
          <span
            style={{
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: 'Arial, Helvetica, sans-serif',
              color: '#be185d',
              whiteSpace: 'nowrap',
            }}
          >
            Programmatic ad slot
          </span>
        </div>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            backgroundColor: '#f3f4f6',
            color: '#374151',
            border: '1px solid #e5e7eb',
            borderRadius: '4px',
            padding: '2px 6px',
            fontSize: '12px',
            fontWeight: 500,
            fontFamily: 'Arial, Helvetica, sans-serif',
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
        >
          {label}
        </span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '12px' }}>
        {kind === 'primary' && (
          <div style={{ height: '40px', width: '100px', borderRadius: '6px', backgroundColor: '#f3f4f6' }} />
        )}
        <div style={{ height: '14px', borderRadius: '8px', backgroundColor: '#f3f4f6' }} />
        <div style={{ height: '14px', borderRadius: '8px', backgroundColor: '#f3f4f6' }} />
        <div style={{ height: '14px', width: '75%', borderRadius: '8px', backgroundColor: '#f3f4f6' }} />
      </div>

      <div
        style={{
          fontSize: '12px',
          fontFamily: 'Arial, Helvetica, sans-serif',
          color: '#6b7280',
          lineHeight: 1.5,
        }}
      >
        This slot will be filled with the best-fit ad when you publish.
      </div>
    </div>
  );
};
